// extracted by mini-css-extract-plugin
export var regulationsWrapper = "regulations-module--regulationsWrapper--6TUo6";
export var regulationsSection = "regulations-module--regulationsSection--fluVu";
export var regulationsList = "regulations-module--regulationsList--vgDTz";
export var rulesOfConduct = "regulations-module--rulesOfConduct--PalGx";
export var statutoLink = "regulations-module--statutoLink--SNUw7";